import { Component, OnInit } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { GlobalVariable } from '../global';
import { UserApiService } from '../services/user-api.service';

@Component({
  selector: 'app-social-links',
  templateUrl: './social-links.page.html',
  styleUrls: ['./social-links.page.scss'],
})
export class SocialLinksPage implements OnInit {
links;any
  constructor(private server:UserApiService,
    public globals:GlobalVariable,private aib:InAppBrowser) { }

  ngOnInit() {
    this.getSocials()
  }
getSocials(){
  this.globals.loader();
  this.server.getSocials(this.globals.businessHost).subscribe(res=>{
    this.globals.dismiss();
    console.log('social',res)
    if(res.status){
      if(res.business_info.social_media!=null)
      this.links=res.business_info.social_media;
      
    }

  },err=>{
    this.globals.dismiss();

  })

}
visit(link){
  if(link){
    this.aib.create(link,'_system')

  }
  else{
   this.globals.presentToast('No Link Found');

  }

// if(type=='facebook'){
//   if(!this.links.hasOwnProperty('facebook') ){
//     this.globals.presentToast('No Link Found')
//     return
//   }
//   if(this.links.hasOwnProperty('facebook') ){
//     this.aib.create(this.links.facebook,'_system')

//   }
// }
// else if(type=='insta'){
//   if(!this.links.hasOwnProperty('instagram') ){
//     this.globals.presentToast('No Link Found')
//     return
//   }
//   if(this.links.hasOwnProperty('instagram') ){
//   this.aib.create(this.links.instagram,'_system')


//   }

// }
}
}
